// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";

import { ISearchFormProps } from "./common";

// ---------------------------------------------- the component
const SearchForm: FunctionComponent<ISearchFormProps> = ({
  criteria,
  categories,
  onFilter
}) => {
  // ---------------------------------------------- handlers
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => e.preventDefault();

  const handleChange = (
    e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>
  ) => onFilter(e.currentTarget.name, e.currentTarget.value);

  // ---------------------------------------------- effects
  useEffect(() => {
    const selects = document.querySelectorAll("select");

    M.FormSelect.init(selects);
  }, []);

  // ---------------------------------------------- content
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="input-field col s6 m3" style={{ marginBottom: "0px" }}>
          <select
            id="prop"
            name="prop"
            defaultValue={criteria.prop}
            onChange={handleChange}
          >
            <option value="title">Title</option>

            <option value="author">Author</option>
          </select>

          <label htmlFor="prop">find by</label>
        </div>

        <div className="input-field col s6 m3" style={{ marginBottom: "0px" }}>
          <select
            id="category"
            name="category"
            defaultValue={"all"}
            onChange={handleChange}
          >
            <option value={"all"}>All</option>

            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>

          <label htmlFor="category">category</label>
        </div>

        <div className="input-field col s12 m6" style={{ marginBottom: "0px" }}>
          <i className="material-icons prefix">search</i>

          <input
            type="text"
            id="keywords"
            name="keywords"
            autoComplete="off"
            onChange={handleChange}
            required
          />

          <label htmlFor="search">your keywords</label>
        </div>
      </div>
    </form>
  );
};

export default SearchForm;
